import { Environment } from './environment.model';
import { oktaSsoEnabled } from './modifiers/okta-sso-enabled';

export const baseenv: Omit<Environment, 'apiUrl'> = {
  ...oktaSsoEnabled,
  production: false,
  baseHref: false,
  application: 'yamahamotorprotectionplanca',
  version: require('../../package.json').version,
  OAuthTokenApi: 'http://mule-worker-internal-sgi-yamahaca-exp-api-dev.us-e1.cloudhub.io:8091/token',
  authMock: false,
  recaptchaSiteKey: '6LdwwasUAAAAAIuGozE0DtbOObT3eP3JTZRWhBo_',
  prismicAccessToken:
    'MC5ZV1FtV1JJQUFDa0EwX0hS.77-977-977-9VEvvv70FGy_vv71D77-977-9Uu-_vQXvv73vv73vv73vv71t77-977-977-977-9KiTvv70o77-977-977-9',
  prismicUid: 'yam-ca',
  prismicTypeId: 'my.yam-ca.uid',
};
